import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useImperativeHandle, forwardRef } from 'react';
import { isTouchDevice } from '../../utils';
import { useControllableProp, useDropdown, useKeyControlledList } from '../../hooks';
import { SelectBtn } from './SelectBtn';
import { SelectDropdown } from './SelectDropdown';
import { Popup } from '../popup/Popup';
export const CustomSelectWithoutSearch = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
({ name, defaultValue, value, items, hasClearBtn = true, isHovered, isDisabled, isInvalid, isLoading, noItemsMessage, renderValue, renderItem, onChange, children, testId, }, ref) => {
    const popupTriggerRef = useRef(null);
    const popupContentRef = useRef(null);
    const btnRef = useRef(null);
    const [currentValue, setCurrentValue] = useControllableProp({
        value: value,
        defaultValue: defaultValue,
    });
    const [keyControlledListItemIndex, handleListControllerKeyDown, resetKeyControlledList] = useKeyControlledList(items.length);
    const [isDropdownShown, setDropdownShown, handleDropdownKeyDown] = useDropdown(popupTriggerRef, popupContentRef, resetKeyControlledList);
    const popupPosition = [
        'bottom-right',
        'bottom-center',
        'bottom-left',
        'top-right',
        'top-center',
        'top-left',
    ];
    useImperativeHandle(ref, () => ({
        focus: () => {
            if (!isTouchDevice()) {
                btnRef.current && btnRef.current.focus();
            }
        },
    }));
    function updateValue(e, newValue) {
        setCurrentValue?.(newValue);
        onChange(e, { value: newValue, name: name });
    }
    function handleBtnClick() {
        setDropdownShown(!isDropdownShown);
    }
    function handleBtnKeyDown(e) {
        handleDropdownKeyDown(e);
        handleListControllerKeyDown(e);
        switch (e.keyCode) {
            case 13: // Enter
                if (isDropdownShown && keyControlledListItemIndex !== undefined) {
                    e.preventDefault();
                    handleItemClick(e, {
                        data: { item: items[keyControlledListItemIndex], hideDropdown: true },
                    });
                }
                break;
        }
    }
    function handleItemClick(e, eventData) {
        setDropdownShown(false);
        updateValue(e, eventData.data.item);
        btnRef.current?.focus();
    }
    function handleClearBtnClick(e) {
        setDropdownShown(false);
        updateValue(e, null);
    }
    return (_jsxs("div", { className: 'sg-customSelect', ref: popupTriggerRef, "data-icon-btn-hover": true, children: [_jsx(SelectBtn, { ref: btnRef, name: name, buttons: children, isHovered: isHovered, isDisabled: isDisabled, isInvalid: isInvalid, onClearBtnClick: hasClearBtn ? handleClearBtnClick : undefined, onKeyDown: handleBtnKeyDown, onClick: handleBtnClick, testId: testId, children: currentValue ? renderValue(currentValue) : '' }), isDropdownShown && (_jsx(Popup, { position: popupPosition, triggerRef: popupTriggerRef, sameWidthAsTrigger: true, children: _jsx("div", { ref: popupContentRef, "data-test-id": testId && `${testId}-dropdown`, children: _jsx(SelectDropdown, { activeItemIndex: keyControlledListItemIndex, items: items, isLoading: !!isLoading, noItemsMessage: noItemsMessage, renderItem: renderItem, onItemClick: handleItemClick, testId: testId }) }) }))] }));
});
//# sourceMappingURL=CustomSelectWithoutSearch.js.map